import { useCallback } from 'react';
import { usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';

const useFieldChangeNotifier = () => {
  const { updatePA } = usePADomainModel();

  const handleChange = useCallback((event: any) => {
    const { name, value } = event.target;
    updatePA(name, value);
  }, [updatePA]);

  return handleChange;
};

export default useFieldChangeNotifier;
